module.exports = __webpack_public_path__ + "img/acv.086e21b1.png";